import * as msal from "@azure/msal-browser";
import router from "./router";
import g from "@/interfaces/GlobalData.js";

const LOGIN_HINT = "cars-loginhint";

let loginRequest = {
  extraQueryParameters: { domain_hint: "cobbvantress.com" },
  //scopes: ["openid", "profile", "User.Read", "AppRoleAssignment.ReadWrite.All", "User.ReadWrite"],
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

let apiTokenRequest = {
  scopes: ["api://287edb7a-c97d-4b1a-92d7-47a23f80c147/User.ReadWrite"],
  forceRefresh: false // set this to "true" if you would like to skip a cached token and go to the server
};

const apiConfig = {
  auth: {
    clientId: "0b165fa6-ea79-4fae-93dd-1beb6f5dbec4",
    authority:
      "https://login.microsoftonline.com/da45342c-ce89-44fe-82c9-2c8502e05791/",
    redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI,
    postLogoutRedirectUri: "http://intranet.cobb-vantress.com" //process.env.VUE_APP_MSAL_REDIRECT_URI
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false
  }
};

const msalApp = new msal.PublicClientApplication(apiConfig);

export default {
  getMsalApp() {
    return msalApp;
  },
  getLoginHint() {
    return localStorage.getItem(LOGIN_HINT);
  },
  getHeaders(accessToken) {
    const headers = new Headers();
    const bearer = `Bearer ${accessToken}`;

    headers.append("Authorization", bearer);

    return headers;
  },

  async login() {
    try {
      let response = await msalApp.loginPopup(loginRequest);
      localStorage.setItem(LOGIN_HINT, response.account.username);
      return response.account;
    } catch (error) {
      console.error(error);
    }
  },

  async ssoSilent(desiredRoute) {
    let response = null;
    console.log({desiredRoute: desiredRoute});
    if (!desiredRoute || desiredRoute === '/' || desiredRoute === '/sales/cars/') {
      desiredRoute = router.currentRoute.fullPath;
    }
    try {
      let loginHint = this.getLoginHint();
      if (loginHint == null) {
        this.navigateToSignIn(desiredRoute);
      } else {
        loginRequest.loginHint = loginHint;

        let loginResponse = await msalApp.ssoSilent(loginRequest);
        if (loginResponse) {
          response = loginResponse.account;

          if (desiredRoute !== null && desiredRoute !== undefined) {
            this.navigateToPath(desiredRoute);
          }
          else {
            this.navigateToHome();
          }
        } else {
          localStorage.removeItem(LOGIN_HINT);
          this.navigateToSignIn(desiredRoute);
        }
      }
    } catch (error) {
      console.info("Failed ssoSilent login", error);
      this.navigateToSignIn(desiredRoute);
    }

    return response;
  },
  async acquireToken() {
    if (!msalApp) {
      return null;
    }

    const loginHint = this.getLoginHint();
    const account = msalApp.getAccountByUsername(loginHint);

    if (account == null) {
      return null;
    }

    // Set scopes for token request
    const accessTokenRequest = {
      scopes: apiTokenRequest.scopes,
      account: account,
      forceRefresh: apiTokenRequest.forceRefresh,
      redirectUri: process.env.VUE_APP_MSAL_REDIRECT_URI
    };

    let tokenResp = null;

    try {
      tokenResp = await msalApp.acquireTokenSilent(accessTokenRequest);
    } catch (error) {
      tokenResp = await msalApp.acquireTokenPopup(accessTokenRequest);
    }
    console.log("tokenResp", tokenResp);

    // Just in case check, probably never triggers
    if (!tokenResp.accessToken) {
      throw new Error("### accessToken not found in response");
    }

    //await this.updatePendingTransactionsAuth(tokenResp.accessToken);
    return tokenResp.accessToken;
  },

  clearLocal() {
    if (msalApp) {
      msalApp.cacheStorage.clear();
    }
  },

  signOut() {
    if (!msalApp) {
      return null;
    }

    msalApp.logout();
  },
  async updatePendingTransactionsAuth(bearerToken) {
    let pendingTransactions = await g.getPendingTransactions();

    pendingTransactions.forEach(async pt => {
      pt.bearerToken = `bearer ${bearerToken}`;
    });

    await g.updatePendingTransactions(pendingTransactions);
  },
  navigateToSignIn(desiredRoute) {
    router.push({ name: "Signin", params: { desiredRoute: desiredRoute } });
  },
  navigateToHome() {
    this.navigateToPath("/");
  },
  navigateToPath(goToPath) {
    if (router.currentRoute.path !== goToPath) {
      router.push({ path: goToPath });
    }
  }
};
